import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = DefaultAnalyticsConfig.erTag;

if (process.env.ENV === "production") {
  erTag = "783f90e8e6f64dd7a8dd19402b24ff2c";
}

export default class analyticsConfig extends DefaultAnalyticsConfig {
  static gaTag = "UA-254285504";
  static erTag = erTag;
  static cmp = {
    hasPreferenceView: true,
    accountId: 348,
    privacyManagerId: 780851,
    propertyId: 30434,
    wrapperMessaging:
      "https://sp-consent.frankenpost.de/unified/wrapperMessagingWithoutDetection.js",
    mmsDomain: "https://zeitung.frankenpost.de",
    baseEndpoint: "https://sp-consent.frankenpost.de",
    features: {
      ER: true,
      GA: true,
    },
    GA: {
      vendorId: "5e542b3a4cd8884eb41b5a72",
      purposeId: ["60ae3dfb2022f823f6c23a68", "60ae3dfb2022f823f6c23a71"],
    },
    ER: {
      vendorId: "5fa53d170b50cd88f2e54dcf",
      purposeId: ["60ae3dfb2022f823f6c23a71"],
    },
    siteId: 780851,
  };

  static weekliOptions = {
    key: "8B07B946-EBC9-4AA9-BB56-5CE1C178D4BC",
    ID: 493, //1533
    config: 1533, //493
    host: "epaper-frankenpost.weekli.de",
  };
}



// WEBPACK FOOTER //
// ./clients/SWMH-FP/js/analyticsConfig.js